import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'lxJuniorCampAges',
})
export class JuniorCampAgesPipe implements PipeTransform {
  transform(minAge: number, maxAge: number): string {
    if (!minAge && !maxAge) {
      return '';
    }

    return `AGES ${minAge} to ${maxAge}`;
  }
}
